import { Users } from 'lucide-react'
import { useNavigate } from 'react-router-dom'

interface TeamTagProps {
  team?: {
    id: string
    name: string
    avatar_url?: string
    is_personal?: boolean
  } | null
  size?: 'sm' | 'md' | 'lg'
  className?: string
}

export const TeamTag = ({ team, size = 'md', className = '' }: TeamTagProps) => {
  const navigate = useNavigate()
  
  // Don't show tag if no team or if it's a personal team
  if (!team || team.is_personal) {
    return null
  }

  const handleClick = (e: React.MouseEvent) => {
    e.stopPropagation() // Prevent parent click handlers (like card navigation)
    navigate(`/teams/${team.id}`)
  }

  const sizeClasses = {
    sm: {
      container: 'px-2 py-1 gap-1.5',
      avatar: 'w-5 h-5',
      icon: 'w-3 h-3',
      text: 'text-xs'
    },
    md: {
      container: 'px-3 py-2 gap-2.5',
      avatar: 'w-7 h-7',
      icon: 'w-4 h-4',
      text: 'text-sm'
    },
    lg: {
      container: 'px-4 py-2.5 gap-3',
      avatar: 'w-9 h-9',
      icon: 'w-5 h-5',
      text: 'text-base'
    }
  }

  const sizes = sizeClasses[size]

  return (
    <button
      onClick={handleClick}
      className={`inline-flex items-center ${sizes.container} bg-gray-50 dark:bg-gray-800/50 hover:bg-gray-100 dark:hover:bg-gray-700/50 rounded-lg border border-gray-200 dark:border-gray-700 hover:border-gray-300 dark:hover:border-gray-600 transition-all hover:scale-105 active:scale-95 ${className}`}
    >
      {team.avatar_url ? (
        <img 
          src={team.avatar_url} 
          alt={team.name}
          className={`${sizes.avatar} rounded-md object-cover`}
        />
      ) : (
        <div className={`${sizes.avatar} bg-orange-100 dark:bg-orange-900/30 rounded-md flex items-center justify-center`}>
          <Users className={`${sizes.icon} text-orange-600 dark:text-orange-400`} />
        </div>
      )}
      <span className={`${sizes.text} font-medium text-gray-700 dark:text-gray-300`}>
        {team.name}
      </span>
    </button>
  )
}

